import React from 'react';
import TranslateIgnoreText from '@this/components/shared/text/translate_ignore_text';
import { digits } from '@this/src/util/price/price.util';
import TripDescriptionContent from './trip_description_content';
import { MarketLogContent } from './market_log_content';
import {
  type OrderItemDescriptionProps,
  formatTravelerText,
  SectionDescText,
  OutlineBox,
  SectionApplication,
  SectionApplicationInfo,
  SectionApplicationBox,
  SectionLabel,
  SectionMarket,
  SectionPrice,
  SectionBudgetHr
} from './shared';

const OrderItemDescription: React.FC<OrderItemDescriptionProps> = ({
  ticketStateType,
  trip,
  tripId,
  orderItem,
  changedPrice
}) => {
  const firstItem = orderItem.firstItem;
  const soldOut = orderItem.soldOut || ticketStateType === 'noFlight';
  const firstItemPrice = orderItem.firstItem?.price?.price || 0;
  const isPriceChanged = firstItemPrice !== changedPrice;

  return (
    <OutlineBox>
      <SectionApplicationBox>
        {orderItem.elements.map((el, j) => {
          // types の index は交通要素の並び順が正。非交通要素は経路別の値を持たないため undefined を渡す
          const transportIndex = orderItem.transportIndexOfElement(el);
          const shinkansenTypeIndex = transportIndex > -1 ? transportIndex : undefined;
          return (
            <SectionApplication key={el.id}>
              <SectionLabel>
                <p data-wovn-ignore>{`【${el.title}】`}</p>
              </SectionLabel>

              <SectionApplicationInfo>
                <TripDescriptionContent
                  el={el}
                  firstEl={firstItem?.elements[j]}
                  orderItem={orderItem}
                  elementIndex={shinkansenTypeIndex}
                  isPackage={orderItem.isPackage}
                  flightPriceChangeDetail={orderItem.price?.flightPriceChangeDetail ?? ''}
                />
                {orderItem.travelerInformations
                  .filter(tst => tst.showRailwaySeat)
                  .map((tst, index) => {
                    let actualIndex = trip.travelerInformations.findIndex(t => t.userId === tst.userId);
                    if (actualIndex === -1) {
                      actualIndex = trip.travelerInformations.findIndex(t => t.travelerName === tst.travelerName);
                    }

                    if (actualIndex === -1) {
                      actualIndex = index;
                    }

                    return (
                      <TranslateIgnoreText
                        key={tst.id}
                        text={formatTravelerText(el, tst, actualIndex, shinkansenTypeIndex)}
                      />
                    );
                  })}
                <SectionBudgetHr />
              </SectionApplicationInfo>

              <SectionMarket>
                <MarketLogContent tripId={tripId} el={el} />
              </SectionMarket>
            </SectionApplication>
          );
        })}

        <SectionApplication>
          <SectionLabel>
            <span />
          </SectionLabel>
          <SectionApplicationInfo>
            <SectionPrice>
              <span>{orderItem.orderItemCategoryText}</span>
              <span>
                <SectionDescText isOld={soldOut || isPriceChanged} data-testid="order-item-price">
                  <span data-wovn-ignore>{digits(firstItemPrice)}</span>
                  <span>円</span>
                </SectionDescText>
                {soldOut ? (
                  <SectionDescText isOld={false} className="red">
                    {ticketStateType === 'noFlight' ? '満席' : '売り切れ'}
                  </SectionDescText>
                ) : isPriceChanged ? (
                  <SectionDescText isOld={false} className="red">
                    <span data-wovn-ignore>{digits(changedPrice)}</span>
                    <span>円</span>
                  </SectionDescText>
                ) : null}
              </span>
            </SectionPrice>
            {orderItem.price?.margin && orderItem.price.margin.amount !== 0 && (
              <SectionPrice>
                <span>手数料</span>
                <span data-wovn-ignore>{digits(orderItem.price.margin.amount)}円</span>
              </SectionPrice>
            )}
            {/* orderItem.bufferAmountが0のとき0が表示されるためboolean化 */}
            {!!orderItem.bufferAmount && orderItem.bufferAmount > 0 && (
              <SectionPrice>
                <span>値上がり許容幅</span>
                <span data-wovn-ignore>{digits(orderItem.bufferAmount)}円</span>
              </SectionPrice>
            )}
          </SectionApplicationInfo>
          <SectionMarket>
            <span />
          </SectionMarket>
        </SectionApplication>
      </SectionApplicationBox>
    </OutlineBox>
  );
};

export default OrderItemDescription;
